import { render } from "./ShowReminder.vue?vue&type=template&id=18d177ec"
import script from "./ShowReminder.vue?vue&type=script&lang=js"
export * from "./ShowReminder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__